import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from './store';
import { Trade } from './wsTokenSlice';

export interface WsSimpleTokenState {
  block_num: number;
  chain_id: number;
  change_24: string;
  mkt_cap: string;
  token_address: string;
  token_price: string;
  txs_24h: number;
  vol_24h: string;
  holder_count: number;
}

interface WsSipmleTokenStates {
  [key: string]: WsSimpleTokenState;
}

const initialState: Partial<WsSipmleTokenStates> = {};

export const wsSimpleTokenSlice = createSlice({
  name: 'wsSimpleToken',
  initialState,
  reducers: {
    updateWsSimpleToken: (state, action: PayloadAction<WsSimpleTokenState>) => {
      let data = { ...state };
      data[action.payload.token_address] = action.payload;
      return {
        ...state,
        ...data,
      };
    },
    clearWsSimpleToken: (state) => {
      return initialState;
    },
  },
});

// 导出 actions
export const { updateWsSimpleToken, clearWsSimpleToken } =
  wsSimpleTokenSlice.actions;

// 导出 selectors
export const selectWsSimpleToken = (state: RootState) => state.wsSimpleToken;
export const selectWsSimpleTokens = (state: RootState) =>
  state.wsSimpleToken.tokens;

export default wsSimpleTokenSlice.reducer;
